import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { translate } from '@repo/phrase';

import { AssetDrawings } from './asset-drawings.component';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const DrawingsModal = ({ visible, onClose }: Props) => {
    return (
        <Modal handleCloseBtn={onClose} visible={visible}>
            <Sheets
                size="medium"
                aria-label={translate('asset_details_drawings')}
                header={<ModalHeader title={translate('asset_details_drawings')} />}
                footer={null}
            >
                <ModalBody>
                    <AssetDrawings />
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
